(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pnoy-unsubscribe-goodbye"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeAmigaGoodbye = () => {
      const main = document.getElementById('MainContent');
      const template = document.getElementById('pnoy-unsubscribe-goodbye-template');
      if (!main || !(template instanceof HTMLTemplateElement)) return;
  
      const normalize = (text) => text.normalize('NFKC').replace(/\s+/gu, ' ').trim();
      const expected = normalize(template.dataset.nativeConfirmation || '');
      const containers = main.querySelectorAll(':scope > .shopify-email-marketing-confirmation__container');
      const container = containers.length === 1 ? containers[0] : null;
      const confirmation = container && Array.from(container.children).find(
        (element) => element.tagName === 'P' && normalize(element.textContent || '') === expected
      );
      const existing = main.querySelectorAll('[data-pnoy-unsubscribe-goodbye]');
  
      if (!expected || !confirmation) {
        existing.forEach((element) => element.remove());
        return;
      }
      if (container.querySelector('[data-pnoy-unsubscribe-goodbye]')) return;
      existing.forEach((element) => element.remove());
  
      const content = template.content.cloneNode(true);
      if (!content.querySelector('[data-pnoy-unsubscribe-goodbye]')) return;
      container.append(content);
    };
  
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeAmigaGoodbye, { once: true });
    } else {
      initializeAmigaGoodbye();
    }
    window.addEventListener('pageshow', initializeAmigaGoodbye);
  })();
  } catch(e) { console.error(e); }
})();

})();
